<main class="gestion-fiche-repondant-page">
  <div class="gestion-fiche-repondant-page__header">
    <div class="gestion-fiche-repondant-page__header--title">
      <h3>
        {{ $i18next.t(`modules.fiche-repondant.GestionFicheRepondantPage.header.title.${$route.name}`) }}
      </h3>
    </div>
    <fiche-repondant-breadcrumbs />
  </div>
  <transition
    name="fade-fast"
    mode="out-in"
  >
    <m-panel>
      <router-view :key="$route.name" />
    </m-panel>
  </transition>
</main>